import { RSAA } from 'redux-api-middleware';

import * as types from 'atg/redux/actionTypes';

export const createMathematicalBet = betParams => async dispatch => {
  await dispatch({
    [RSAA]: {
      endpoint: 'game/createMathematicalBet',
      method: 'POST',
      body: JSON.stringify(betParams),
      types: [
        { type: types.REQUEST_CREATE_MATHBET, meta: { betParams } },
        { type: types.RECEIVE_CREATE_MATHBET, meta: { betParams } },
        {
          type: types.RECEIVE_CREATE_MATHBET_ERROR,
          meta: { betParams, errorType: 'discrete' },
        },
      ],
    },
  });
};

export function fetchWizSettings({
  amount,
  betType,
  date,
  riskLevel,
  trackKey,
}) {
  const query = new URLSearchParams({
    amount,
    betType,
    date,
    riskLevel,
    trackKey,
  });
  const queryParams = query.toString();

  return {
    [RSAA]: {
      endpoint: `calendar/validWizSettings?${queryParams}`,
      types: [
        { type: types.REQUEST_WIZ_SETTINGS },
        { type: types.RECEIVE_WIZ_SETTINGS },
        {
          type: types.RECEIVE_WIZ_SETTINGS_ERROR,
          meta: { errorType: 'discrete' },
        },
      ],
    },
  };
}
